import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ApiService, ListResult, User } from 'angular-lib';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '../../../services/loader.service';
import { PopupService } from '../../../services/popup.service';
import { BlacklistUnlockPopupComponent } from '../../popup/types/blacklistUnlock/popup-blacklist-unlock.component';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'ez-blacklist',
    template: require('./blacklist.component.html'),
    styles: [require('./blacklist.component.less')]
})

export class BlacklistComponent implements OnInit, OnDestroy {
    public list?: ListResult;
    public page: number = 0;
    public maxPages: number;
    public scrolled: boolean = false;
    public showUnlockModal: boolean = false;
    public sentence: string = '';
    public userToUnlock: User;
    public userToDeleteIndex: number;
    private lastScrollPosition: number = 0;
    constructor(
        private apiService: ApiService,
        private translateService: TranslateService,
        private loaderService: LoaderService,
        private popupService: PopupService,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: any
    ) {
    }

    public ngOnInit() {
        this.getBlacklist();
    }

    public ngOnDestroy(): void {
        this.renderer.removeClass(document.querySelector('#logged-content'), 'fullscreen-mode');
    }

    public onWindowScroll() {
        // if the list exists and has at least 3 elements
        if (typeof this.list !== 'undefined' && this.list.items.length > 3) {
            // get current scroll position
            let scrollPosition = window.scrollY;
            // get max scroll position for this page
            let maxScroll = this.document.documentElement.scrollHeight - this.document.documentElement.clientHeight;
            // get list element height
            let liHeight = this.document.querySelector('#blacklist > div > ul > li').offsetHeight;
            // if we scroll down and current scroll position is more than max - 2 element height, we need to load the next page
            if (scrollPosition > this.lastScrollPosition && scrollPosition > maxScroll - liHeight * 2) {
                this.getBlacklist();
            }
            // and current scroll position will be the last for the next scroll event
            this.lastScrollPosition = scrollPosition;
        }
    }

    public getBlacklist() {
        // prevent to launch multiple api call
        if (this.scrolled === false) {
            this.scrolled = true;
            // if next page exists
            if (this.page < this.maxPages || this.page === 0) {
                this.page += 1;
                // display the loader
                this.loaderService.show();
                // get it
                this.apiService.list(306, this.page).subscribe(
                    (data) => {
                        // hide the loader
                        this.loaderService.hide();
                        // concat to the list if not empty, or just define it if not
                        if (this.list) {
                            this.list.concat(data);
                        } else {
                            this.list = data;
                        }
                        // save the max page
                        this.maxPages = data.pages;
                        // if the list is still empty
                        if (this.list.items.length === 0) {
                            this.renderer.addClass(document.querySelector('#logged-content'), 'fullscreen-mode');
                        }
                        // end of this call
                        this.scrolled = false;
                    },
                    error => {
                        this.loaderService.hide();
                    }
                );
            }
        }
    }

    public showModal(user, index) {
        this.userToDeleteIndex = index;
        this.userToUnlock = user;

        this.translateService.get('profile.unlock-profile').subscribe((str) => {
            this.sentence = str.replace('{displayname}', user.user.displayname);
            this.popupService.showPopup(BlacklistUnlockPopupComponent, {
                sentence: this.sentence
            }).subscribe(data => {
                if (data.result === true) {
                    this.unlock();
                }
                this.popupService.close();
            });
        });
    }

    public unlock() {
        this.showUnlockModal = true;
        this.apiService.blacklist(this.userToUnlock.user, false).subscribe((res) => {
            if (res.result === true) {
                this.showUnlockModal = false;
                // remove item
                this.list.remove(this.userToDeleteIndex);
                // if the list is empty
                if (this.list.items.length === 0) {
                    this.renderer.addClass(document.querySelector('#logged-content'), 'fullscreen-mode');
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/profile/blacklist/blacklist.component.ts